import React, { useState } from 'react';

export const Faq = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);

const faqs = [
  {
    question: "O que é a Igreja Presbiteriana?",
    answer: `A Igreja Presbiteriana é uma denominação cristã de tradição reformada, surgida no contexto da Reforma Protestante do século XVI. Ela se caracteriza pela fidelidade às Escrituras Sagradas, pela centralidade de Cristo e por um sistema de governo eclesiástico exercido por presbíteros.`,
  },
  {
    question: "Qual é a origem histórica da Igreja?",
    answer: `A Igreja Presbiteriana tem suas raízes na Reforma Protestante, especialmente nos ensinos de João Calvino, em Genebra. Esse modelo de igreja se desenvolveu posteriormente na Escócia, com John Knox, e se espalhou para diversas nações.`,
  },
  {
    question: "O que é a Igreja Presbiteriana do Brasil (IPB)?",
    answer: `A Igreja Presbiteriana do Brasil (IPB) foi organizada em 1862 com a chegada do missionário Ashbel Green Simonton. Desde então, a IPB tem atuado na proclamação do evangelho, na educação cristã e no serviço à sociedade brasileira.`,
  },
  {
    question: "Quais são as principais doutrinas da Igreja?",
    answer: `A Igreja Presbiteriana afirma que a Bíblia é a única regra de fé e prática. Entre suas doutrinas centrais estão a soberania de Deus, a salvação pela graça mediante a fé em Jesus Cristo, a autoridade das Escrituras e a glória de Deus como propósito supremo de todas as coisas.`,
  },
  {
    question: "O que é a Confissão de Fé de Westminster?",
    answer: `A Confissão de Fé de Westminster é um documento histórico do século XVII que sistematiza os principais ensinos das Escrituras conforme a fé reformada. Ela não substitui a Bíblia, mas serve como um resumo fiel da doutrina bíblica adotada pela Igreja Presbiteriana.`,
  },
  {
    question: "O que são os Catecismos da Igreja Presbiteriana?",
    answer: `Os Catecismos de Westminster, especialmente o Breve Catecismo e o Catecismo Maior, são instrumentos de ensino em formato de perguntas e respostas, utilizados para instrução cristã de crianças, jovens e adultos na fé bíblica.`,
  },
  {
    question: "O que a Igreja ensina sobre a Bíblia?",
    answer: `A Igreja Presbiteriana confessa que a Bíblia é inspirada por Deus, verdadeira em tudo o que ensina e suficiente para orientar a fé e a vida cristã. Por essa razão, a pregação e o ensino das Escrituras ocupam lugar central em seus cultos.`,
  },
  {
    question: "O que são os sacramentos na Igreja Presbiteriana?",
    answer: `A Igreja Presbiteriana reconhece dois sacramentos instituídos por Cristo: o Batismo e a Ceia do Senhor. Eles são sinais visíveis da graça de Deus e meios pelos quais Ele fortalece a fé do seu povo.`,
  },
  {
    question: "O que a Igreja ensina sobre a salvação?",
    answer: `A salvação é compreendida como um dom da graça de Deus, concedido mediante a fé em Jesus Cristo, e não por obras humanas. Cristo é reconhecido como o único mediador entre Deus e os homens.`,
  },
  {
    question: "Como funciona o sistema de governo da Igreja?",
    answer: `A Igreja Presbiteriana é governada por presbíteros eleitos pela igreja local. Esses líderes atuam de forma colegiada em concílios, que incluem o conselho local, o presbitério, o sínodo e o supremo concílio.`,
  },
  {
    question: "Qual é a missão da Igreja Presbiteriana?",
    answer: `A missão da Igreja Presbiteriana é glorificar a Deus por meio da proclamação do evangelho de Jesus Cristo, do ensino das Escrituras, da comunhão entre os irmãos e do serviço responsável à sociedade.`,
  },
];



  const handleToggle = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

  return (
    <div id="faq" className="faq-container">
      <h2><i className="fa fa-question-circle" style={{ marginRight: '10px' }}></i>Conhecendo a Igreja Presbiteriana</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => handleToggle(index)}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              {faq.question}
            </div>
            {activeQuestion === index && (
              <div className="faq-answer" style={{ marginTop: '10px' }}>
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};


